import Api from "../../../../util/Api";
export default function getInitState() {
    return {
        additionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
          },
        partnerFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGridFromPartnerForm'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetPartnerForm'
            }
        ],
        partnerSiteFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGridFromPartnerSiteForm'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetPartnerSiteForm'
            }
        ],
        contactFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToContactGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetContactForm'
            }
        ],
        positionsRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyPositionsRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deletePositionsRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeletePositionRow'
            }
        ],
        contactRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyContactRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteContactRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteContactRow'
            }
        ],
        employeesRowActions: [
            {
                btn_text: '<i class="fas fa-exchange-alt"></i>',
                title: 'Munkavállaló áthelyezése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'moveEmployeesRow'
            },
            {
                btn_text: '<i class="fas fa-file-signature"></i>',
                title: 'Jogviszony szerkesztése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                seeCaseOfDeleted: false,
                event_payload: 'employmentRelationshipEdit'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteEmployeesRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeletePatientRow'
            }
        ],
        positionsActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToGridFromPositionsGrid'
            },
            // {
            //     btn_text: '<i class="fas fa-filter"></i> Szűrés',
            //     event_name: "customClick",
            //     class: "btn btn-primary my-custom-class",
            //     event_payload: 'showGroupSearchModal'
            // },
            {
                btn_text: '<i class="fas fa-plus"></i> Új munkakör',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newPositionRow'
            }
        ],
        contactActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToGridFromContactGrid'
            },
            // {
            //     btn_text: '<i class="fas fa-filter"></i> Szűrés',
            //     event_name: "customClick",
            //     class: "btn btn-primary my-custom-class",
            //     event_payload: 'showContactSearchModal'
            // },
            {
                btn_text: '<i class="fas fa-plus"></i> Új kapcsolattartó',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newContactRow'
            }
        ],
        employeesActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Munkavállaló hozzáadása',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'showAddEmployees'
            }
        ],
        positionsFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToPositionsGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetPositionsForm'
            }
        ],
        posotionsDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        contactDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        contactSearchFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3
            },
            {
                name: "email",
                label: "E-mail cím",
                formType: "email",
                formSize: 3
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formSize: 3
            }
        ],
        partnerFields: [
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "taxNumber",
                label: "Adószám",
                visibility: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "registrationNumber",
                label: "Cégjegyzékszám",
                visibility: false,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "branchOfNationalEconomyId",
                label: "Nemzetgazdasági ág",
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getOccupationHealthJobBranchOfNationalEconomy,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true,
                formRequired: true,
            },
            {
                name: "isEmployeeIdUnique",
                label: "A törzsszám az elsődleges azonosító",
                visibility: false,
                formType: 'checkbox',
                formSize: 3,
                formVisible: true,
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true,
            },
            {
                name: "employeeIdNotEditable",
                label: "Törzsszám nem módosítható",
                formType: "checkbox",
                formVisible: true,
                formSize: 2,
            },
        ],
        contactHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail cím",
                sort: true,
                formRequired: true,
                formType: "email",
                formSize: 3,
                formVisible: true
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                visibility: true,
                formType: "tel",
                formSize: 3,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        employeesHeaderFields: [
            {
                name: "name",
                label: "Név",
            },
            {
                name: "employeeId",
                label: "Vállalati azonosító (törzsszám)",
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
            },
            {
                name: "workEmail",
                label: "Munkahelyi E-mail",
            },
            {
                name: "motherName",
                label: "Anyja neve",
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                slot_name: "settingDateFormatDateOfBirth",
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
            },
            {
                name: "siteGroupName",
                label: "Munkakör",
            },
            {
                name: "supervisorNames",
                label: "Felettesek",
            },
            {
                name: "employmentRelationshipStartDate",
                label: "Jogviszony kezdete",
                slot_name: "settingDateFormatEmploymentRelationshipStartDate",
                formVisible: true,
                formSize: 4,
                formType: "date",
                formRequired: false,
            },
            {
                name: "employmentRelationshipEndDate",
                label: "Jogviszony vége",
                slot_name: "settingDateFormatEmploymentRelationshipEndDate",
                formVisible: true,
                formSize: 4,
                formType: "date",
            },
            {
                name: "status",
                label: "Státusz",
                slot_name: "formatEmployeeStatus",
            },
            {
                name: "isConnectedToManager",
                label: "Menedzser",
                formType: "checkbox",
                formSize: 4,
                formVisible: true,
                visibility: true,
                slot_name: "isConnectedToManagerFormat"
            },
            {
                name: "buttons",
                label: "Opciók",
                formVisible: false,
            }
        ],
        employeesSearchFields: [
            {
                name: "patientName",
                label: "Név",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "employeeId",
                label: "Vállalati azonosító (törzsszám)",
                formVisible: true,
                formSize: 3,

            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                formType: "tel",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "email",
                label: "E-mail cím",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "motherName",
                label: "Anyja neve",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                slot_name: "date_format",
                formType: "date",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "employeePosition",
                label: "Munkakör",
                formVisible: true,
                formSize: 3,
                
            },
            {
                name: "supervisorNames",
                label: "Felettesek",
                formSize: 3,
                formVisible: true,
            },
            {
                name: "employmentRelationshipStartDate",
                label: "Jogviszony kezdete",
                slot_name: "resultDate_format",
                formVisible: true,
                formSize: 4,
                formType: "date",
            },
            {
                name: "employmentRelationshipEndDate",
                label: "Jogviszony vége",
                slot_name: "startDate_format",
                formVisible: true,
                formSize: 4,
                formType: "date",
            },
        ],
        positionsHeaderFields:[
            {
                name: "name",
                label: "Munkakör megnevezése",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 4,
                formVisible: true,
                filter: {
                    type: "simple",
                },
            },
            // {
            //     name: "jobCategory.text",
            //     label: "FEÜ kategória",
            //     sort: true,
            //     visibility: true,
            //     filter: {
            //         type: "simple",
            //     }
            // },
            // {
            //     name: "jobCategoryId",
            //     label: "FEÜ kategória",
            //     formRequired: true,
            //     formType: "select",
            //     formSize: 4,
            //     formVisible: true,
            //     visibility: false,
            //     filter: {
            //         type: "simple",
            //     },
            //     selectOptions: {
            //         apiCallback: Api.getOccupationHealthJobCategories,
            //         formatText: function (val) {
            //             return val.text;
            //         },
            //         formatOption: function (val) {
            //             return val.text;
            //         },
            //         minimumInputLength: 0,
            //         searchOnServer: false,
            //         filteredAttr: 'text',
            //         returnValue: 'id',
            //         locale: {
            //             searchPlaceholder: 'Keresés...',
            //             noResults: 'Nincs találat'
            //         }
            //     },
            // },
            {
                name: "groupCode",
                label: "FEOR elnevezés",
                sort: true,
                formType: "select",
                formSize: 4,
                formVisible: true,
                filter: {
                    type: "simple",
                },
                selectOptions: {
                    apiCallback: Api.getOccupationalHealthJobs,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "description",
                label: "Leírás",
                sort: true,
                formType: "textarea",
                formSize:4,
                formVisible: true,
                filter: {
                    type: "simple",
                }
            },
            {
                name: "positionCode",
                label: "Munkakör azonosító",
                formRequired: true,
                formType: "number",
                formSize: 4,
                formVisible: true,
                filter: {
                    type: "simple",
                }
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false,
                
            }
        ],
        employeesFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToEmployeesGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetEmployeesForm'
            },
            {
                btn_text: 'Mentés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveNewEmployees'
            },
        ],
        
    }
}
